import React from 'react';
import { useTranslation } from 'react-i18next';
import './footer.css';
import FooterIcon from '../common/footericon';
import logoImg from '../../asserts/logo.png';
import emailImg from '../../asserts/icf.png';
import phoneImg from '../../asserts/icf1.png';
import locationImg from '../../asserts/icf2.png';

const Footer = () => {
    const { t } = useTranslation();
    return (
        <>
            <footer>
                <section className='footer-col footer-brand'>
                    <img src={logoImg} alt="EventHub Logo" className='footer-logo' />
                    <p className='footertext'>
                        {t('footer_desc')}
                    </p>
                    <div className='footer-socials'>
                        <FooterIcon type="facebook" />
                        <FooterIcon type="twitter" />
                        <FooterIcon type="instagram" />
                    </div>
                </section>

                <section className='footer-col'>
                    <p className='footertitle'>{t('footer_quick_links')}</p>
                    <p className='footer-link'>{t('footer_browse')}</p>
                    <p className='footer-link'>{t('nav_categories')}</p>
                    <p className='footer-link'>{t('nav_about')}</p>
                    <p className='footer-link'>{t('footer_how_it_works')}</p>
                    <p className='footer-link'>{t('footer_pricing')}</p>
                </section>

                <section className='footer-col'>
                    <p className='footertitle'>{t('footer_event_types')}</p>
                    <p className='footer-link'>{t('sec3_cat_concerts')}</p>
                    <p className='footer-link'>{t('sec3_cat_comedy')}</p>
                    <p className='footer-link'>{t('sec3_cat_theatre')}</p>
                    <p className='footer-link'>{t('sec3_cat_talks')}</p>
                    <p className='footer-link'>{t('sec3_cat_workshops')}</p>
                </section>

                <section className='footer-col'>
                    <p className='footertitle'>{t('footer_contact_us')}</p>
                    <div className='footer-contact-item'>
                        <img src={emailImg} alt="Email" className='contact-icon-img' />
                        <span className='footertext'>hello@foxevents.com</span>
                    </div>
                    <div className='footer-contact-item'>
                        <img src={phoneImg} alt="Phone" className='contact-icon-img' />
                        <span className='footertext'>+1 (234) 567-890</span>
                    </div>
                    <div className='footer-contact-item'>
                        <img src={locationImg} alt="Location" className='contact-icon-img' />
                        <span className='footertext'>123 Event Street, San Francisco, CA 94102</span>
                    </div>
                </section>
            </footer>

            <div className='bottom-footer'>
                <span className='bottom-copy'>© 2026 EventHub. {t('footer_rights')}</span>
                <div className='bottom-links'>
                    <p className='bottom-link'>{t('footer_privacy')}</p>
                    <p className='bottom-link'>{t('footer_terms')}</p>
                    <p className='bottom-link'>{t('footer_cookie')}</p>
                </div>
            </div>
        </>
    );
};

export default Footer;